"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgVideoOff = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_VIDEO-OFF", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M11.629 3.79c-.135-.71-.283-1.22-.402-1.445-.124-.235-.376-.345-.641-.345H1.414c-.265 0-.517.11-.64.345C.477 2.903 0 5.235 0 8c0 1.339.06 2.37.152 3.168l1.913-1.23C2.025 9.298 2 8.608 2 8c0-1.473.148-3.424.292-4h7.417c.046.188.094.521.136.936L11.63 3.79ZM1.017 14h9.569c.265 0 .517-.11.641-.345.295-.558.773-1.89.773-5.655 0-.296-.005-.588-.015-.873L13 6.474v3.037l2.133 2.326a.5.5 0 0 0 .867-.341V3.99a1 1 0 0 0-1.54-.83L.458 12.158a1 1 0 0 0-.3 1.382c.226.352.516.459.858.459Zm3.388-2 5.592-3.595c-.023 1.406-.157 3.07-.288 3.595H4.405Z" }))); };
exports.default = SvgVideoOff;
